import { useMemo, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import qs from "qs";
import { QUERY_PARAMS } from "../constants/constants";
import { ORDER_BY } from "pages/admin-app/adminapp.constants";

interface Props {
  currentPage: number;
  sortBy: string;
  orderBy: ORDER_BY;
  filters: Record<string, string>;
  searchQuery: string;
}

export default function useQueryParams({
  currentPage,
  sortBy,
  orderBy,
  filters,
  searchQuery,
}: Props) {
  const location = useLocation();
  const history = useHistory();

  const queryParams = useMemo(() => {
    const paramsObj = {
      [QUERY_PARAMS.PAGE]: currentPage.toString(),
      [QUERY_PARAMS.SORT_BY]: sortBy,
      [QUERY_PARAMS.ORDER_BY]: orderBy,
    };
    if (searchQuery.trim() !== "") {
      paramsObj[QUERY_PARAMS.SEARCH_QUERY] = searchQuery;
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        paramsObj[`${QUERY_PARAMS.FILTERS}[${key}]`] = value;
      }
    });
    return qs.stringify(paramsObj, { encode: false });
  }, [currentPage, sortBy, orderBy, filters, searchQuery]);

  useEffect(() => {
    if (queryParams !== location.search.substring(1)) {
      history.replace({ search: "?" + queryParams });
    }
  }, [queryParams, history, location.search]);

  return queryParams;
}
